/** Sent as `permission_context` on shared dashboard report APIs to separate access checks. */
export type ReportPermissionContext = 'dashboard' | 'sales_report' | 'sales_analytics';

export const REPORT_PERMISSION_CONTEXT = {
  DASHBOARD: 'dashboard' as ReportPermissionContext,
  SALES_REPORT: 'sales_report' as ReportPermissionContext,
  SALES_ANALYTICS: 'sales_analytics' as ReportPermissionContext,
};
